import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.fragment.html',
  styleUrls: [
    './progress.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class ProgressFragment implements OnInit {

  public header = '';
  public msg = '';
  public list: string[] = [];
  public total: number;
  public progress = 0;
  public count = 0;
  public unit = '';
  public errorMode: boolean;
  public errorModeMessage = '';
  public otherInfosMode: boolean;
  public otherInfosModeMessage = '';

  @Output() public closeEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  get progressColor(): ThemePalette {
    if (this.errorMode) {
      return 'warn';
    } else {
      return 'primary';
    }
  }
  private updateProgress(): void {
    if (this.count > this.total) {
      this.progress = 100;
    } else {
      this.progress = Math.round((this.count / this.total) * 100);
    }
  }

  public increment(): void {
    this.count++;
    this.updateProgress();
  }

  public setCount(count: number): void {
    this.count = count;
    this.updateProgress();
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
